import { z } from 'zod'

export const schema = z.object({
  bucket_name: z.string().min(1),
  bucket_type: z.union([
    z.literal('TOP_LEVEL'),
    z.literal('INVESTMENT_TYPE'),
    z.literal('WRAPPER'),
  ]),
})

export type SchemaType = z.infer<typeof schema>
